import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom"

import LoadingScreen from "react-loading-screen";
import Footer from "../footer/Footer";
// import Header from "../header/Header";
import AOS from 'aos';
import VideoManager from "../VideoManager";

import 'aos/dist/aos.css';
import "../../styles/css/project.css";
import "../../styles/css/main.css";
import { url } from "../../inv";

import { getPostByPostId } from "../general_functions/cpanelFunctions";
import { languageConvertor } from "../general_functions/general";

export default function Detail({ allpost, context, footerText }) {
  const [post, setPost] = useState(0);
  const [currentPost, setCurrentPost] = useState(null);
  let { language } = context;

  useEffect(() => {
    getPostById();
  }, [language]);

  const getPostById = () => {
    const linkUrl = window.location.href;
    let linkUrlSplit = linkUrl.split('?');
    let postId = '';
    if (linkUrlSplit.length > 0) {
      postId = linkUrlSplit[1];
    }

    getPostByPostId(postId, res => {
      let localLanguage = localStorage.getItem('language');
      if (localLanguage != null) {
        language = localLanguage;
      }
      
      if (res && res.post) {
        setPost(res.post);
        let { data } = res.post;
        for (let i = 0; i < data.length; i++) {
          if (data[i].language == languageConvertor(language)) {
            setCurrentPost(data[i]);
          }
        }
      }
    });
  }

  return (
    <div style={{ height: "100%", marginTop: 24 }}>
      {/* <Header context={context} /> */}
      <div className={"project-section-main"}>
        <div className={"wrapper"}>
          <div className={"project-card-large"}>
            {currentPost ?
              <div>
                <VideoManager playSize={128}
                  context={context} currentPost={currentPost} post={post} />
                <div className={"project-card-contener"}>
                  <h2 className={"project-card-title"}>{currentPost.value.title}</h2>
                  <h3>{currentPost.value.subTitle}</h3><br />
                  {currentPost.value.details && currentPost.value.details.length > 0 ?
                    currentPost.value.details.map((p, i) => {
                      return (
                        <p>{p}</p>
                      )
                    })
                    : ("")}
                </div>
              </div>
              : ("")}
            {/* <div className={"project-detail-album"}>
                <div className={"project-detail-img-content"}>
                  <img src={detail1} />
                </div>
                <div className={"project-detail-col-content"}>
                  <div className={"project-detail-col"}>
                    <div className={"project-detail-col-img-content"}>
                      <img src={detail2} />
                    </div>
                    <div className={"project-detail-col-img-content"}>
                      <img src={detail4} />
                    </div>
                  </div>
                  <div className={"project-detail-col"}>
                    <div className={"project-detail-col-img-content"}>
                      <img src={detail3} />
                    </div>
                    <div className={"project-detail-col-img-content"}>
                      <img src={detail2} />
                    </div>
                  </div>
                </div>
                <div className={"project-detail-img-content"}>
                  <img src={detail5} />
                </div>
              </div> */}
          </div>
        </div>
        <div className={"wrapper-big"}>
          <div className={"detail-album-contailer"}>
            {post && post.fileNames && post.fileNames.length > 1 ?
              post.fileNames.map((img, i) => {
                return (
                  <div className="detail-album-image-container">
                    <img src={`${url}/public/${img}`} />
                  </div>
                )
              })
              : ("")}
          </div>
        </div>
      </div>
      <div className={"wrapper-big"}>
        <div className={"wrapper"}>
          <Footer context={context} footerText={footerText} />
        </div>
      </div>
    </div>
  );
}